import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { ParentTable } from '@mq/voltron-parent';
import { Table } from '@mq/voltron-table';
import { LoadingOverlay, ToastAlert } from '@mqd/volt-base';
import StyleContext from '../contexts/StyleContext';
import BeneficiariesTableStore from './BeneficiariesTableStore';

class BeneficiariesTable extends ParentTable {
  constructor(props) {
    super(props);
    this.storeConstructor = BeneficiariesTableStore;
    this.state = {
      showChangeStatusModal: false,
      changeStatusModalDefault: null,
      activeStore: null,
      toast: {
        toastMessage: '',
        icon: '',
      },
      ...this.colEditState(props, this.columns()),
    };
  }

  columns() {
    const columns = [
      { header: 'Alias', accessor: 'alias', key: 'alias' },
      { header: 'Account Number', accessor: 'account_number', key: 'account_number' },
      { header: 'Sort Code', accessor: 'sort_code', key: 'sort_code' },
      { header: 'Routing Number', accessor: 'routing_number', key: 'routing_number' },
      { header: 'Status', accessor: 'status', key: 'status' },
      { header: 'Created Time', accessor: 'created_time', key: 'created_time' },
      { header: 'Last Modified Time', accessor: 'last_modified_time', key: 'last_modified_time' },
    ];
    return columns;
  }

  render() {
    const {
      currentList,
      activeSort,
      activeRow,
      setAttr,
      updateKey,
      loading,
      canTransitionAccount,
    } = this.store;
    const { onRowClick } = this.props;

    const { columns, tableKey, toast } = this.state;
    const pageSize = this.store.count;
    const tablePaddingBottom = currentList.length >= pageSize ? 0 : 78;
    return (
      <div style={{ width: '100%' }}>
        <StyleContext.Consumer>
          {({ height }) => {
            return (
              <LoadingOverlay active={loading}>
                <Table
                  key={tableKey}
                  loading={loading}
                  height={height + tablePaddingBottom || this.dynamicHeight}
                  data={currentList}
                  columns={columns}
                  fixedColumnCount={canTransitionAccount ? 1 : 0}
                  rightAlignFixedColumns={true}
                  sort={activeSort}
                  activeRow={activeRow}
                  onSort={(newSort) => {
                    setAttr('activeSort', newSort);
                  }}
                  scrollToTopUpdateKey={updateKey}
                  handleColSizeChange={this.handleColSizeChange.bind(this)}
                  onRowClick={onRowClick}
                />
              </LoadingOverlay>
            );
          }}
        </StyleContext.Consumer>
        {toast.toastMessage && (
          <ToastAlert
            icon={toast.icon}
            dismissTime="3"
            action=""
            remove={() => {
              this.setState({
                ...this.state,
                toast: {
                  toastMessage: '',
                  icon: '',
                },
              });
            }}
          >
            {toast.toastMessage}
          </ToastAlert>
        )}
      </div>
    );
  }
}

BeneficiariesTable.propTypes = {
  height: PropTypes.number,
  storeInitArgs: PropTypes.object,
  store: PropTypes.object,
  userStore: PropTypes.object,
  autoHydrate: PropTypes.bool,
  onStoreConstruction: PropTypes.func,
  gqlClient: PropTypes.any,
  localStorageKey: PropTypes.string,
  onRowClick: PropTypes.func,
};

BeneficiariesTable.defaultProps = {
  height: 800,
  storeInitArgs: {
    limit: 100,
  },
  store: null,
  userStore: {},
  autoHydrate: true,
  onStoreConstruction: null,
  gqlClient: null,
  localStorageKey: 'BeneficiariesTableConfig',
};

export default observer(BeneficiariesTable);
